import {
  DeviceIdProvider,
  DeviceIntelligenceProvider,
  Journey,
} from '@1debit/device-intelligence';
import { TunerProvider } from '@1debit/tuner-web';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'graphql/init';
import { LazyMotion } from 'motion/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from 'containers/App';

import { RouteContextProvider } from 'hooks/useRoutes';

import OptimizelyContainer from 'optimizely/OptimizelyContainer';

import { persistedStore, persistor } from 'store';

import { deviceIntelligenceEnvironment } from 'utils/deviceIntelligenceUtils';
import { removeInstantLoader } from 'utils/instantLoader';
import { buildTunerConfig } from 'utils/tunerHelpers';

const loadMotionFeatures = () =>
  import('utils/framerMotion/features').then(res => res.default);

const DEPLOYMENT_ENVIRONMENT = window.Chime.config.DEPLOYMENT_ENVIRONMENT;
const tunerConfig = buildTunerConfig(DEPLOYMENT_ENVIRONMENT);

export const initApp = ({ optimizelyClient }) => {
  removeInstantLoader();

  if (window.Cypress) {
    window.store = persistedStore;
  }

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <TunerProvider config={tunerConfig}>
      <ApolloProvider client={apolloClient}>
        <Provider store={persistedStore}>
          <DeviceIdProvider environment={deviceIntelligenceEnvironment}>
            <PersistGate loading={null} persistor={persistor}>
              <OptimizelyContainer optimizelyClient={optimizelyClient}>
                <LazyMotion features={loadMotionFeatures}>
                  <RouteContextProvider>
                    <DeviceIntelligenceProvider
                       journey={Journey.Enrollment}
                       apolloClient={apolloClient}
                    >
                      <App />
                    </DeviceIntelligenceProvider>
                  </RouteContextProvider>
                </LazyMotion>
              </OptimizelyContainer>
            </PersistGate>
          </DeviceIdProvider>
        </Provider>
      </ApolloProvider>
    </TunerProvider>
  );
};
